import { LoadingSpinner } from '../components/LoadingSpinner';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router';
import { useCallback, useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { QRScanner } from '../components/QRScanner';
import { NewUserPopup } from '../components/modals/NewUserPopup';
import API from '../service/api';
import { GroupsOperatorPage } from './group';
import { GroupViewerPage } from './group/[id]';
import { OpGroupListItemDTO } from '@scm/common-legacy';

export interface MainPageProps {
    userName: string;
    companyName: string;
}

export const MainPage = ({ userName, companyName }: MainPageProps) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [groups, setGroups] = useState<OpGroupListItemDTO[]>([]);
    const [selectedGroup, setSelectedGroup] =
        useState<OpGroupListItemDTO | null>(null);
    const [qr, setQr] = useState(false);
    const [newUser, setNewUser] = useState(
        localStorage.getItem('newUser') !== null ? 'newUser' : '',
    );

    const navigateToFirst = useCallback((groups: OpGroupListItemDTO[]) => {
        if (window.location.pathname !== '/') return;
        const lastOpGroup = Number(localStorage.getItem('lastopgroup'));

        if (groups.find((g) => g.id == lastOpGroup)) {
            navigate('/group/' + lastOpGroup);
        } else {
            localStorage.removeItem('lastopgroup');
            if (groups.length > 0) navigate('/group/' + groups[0].id);
        }
    }, []);

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const gs = (
                (await API.GET('/api/groups')) as OpGroupListItemDTO[]
            ).sort((a, b) => (b.nrOfMachines ?? 0) - (a.nrOfMachines ?? 0));
            setGroups(gs);
            navigateToFirst(gs);
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, []);

    useEffect(() => {
        if (selectedGroup)
            localStorage.setItem('lastopgroup', String(selectedGroup.id));
    }, [selectedGroup]);

    return (
        <div className="d-flex flex-column h-100">
            {qr && selectedGroup && (
                <QRScanner
                    key={selectedGroup.id}
                    currentGroupId={selectedGroup.id}
                    onClose={() => setQr(false)}
                />
            )}
            {newUser && (
                <NewUserPopup
                    userName={userName}
                    companyName={companyName}
                    withoutWelcome={newUser == 'tutorial'}
                />
            )}

            <Header
                userName={userName}
                onQR={() => setQr(true)}
                onHome={() => {}}
                onHelp={() => setNewUser('tutorial')}
                selectedGroupId={selectedGroup?.id ?? null}
            />

            {loading && <LoadingSpinner />}

            {groups && !loading && (
                <div
                    className="d-flex flex-fill overflow-auto"
                    style={{ background: '#eee' }}
                >
                    <Routes>
                        <Route
                            path=""
                            element={<GroupsOperatorPage groups={groups} />}
                        />

                        <Route
                            path="group/:id/*"
                            element={
                                <GroupViewerPage
                                    userName={userName}
                                    groups={groups}
                                    onLoad={setSelectedGroup}
                                />
                            }
                        />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </div>
            )}
        </div>
    );
};
